import React from 'react';
import { Home, Layers, Grid, PenTool, Video, BoxIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Homestaging',
    description: 'Leere Räume werden zu einladenden Wohnwelten – ohne Möbelverleih.',
    icon: Home
  }, {
    title: 'Fassaden',
    description: 'Außenansichten visualisieren, bevor der erste Stein gesetzt wird.',
    icon: BoxIcon
  }, {
    title: 'Varianten',
    description: 'Mehrere Designoptionen auf Knopfdruck – für fundierte Entscheidungen.',
    icon: Layers
  }, {
    title: 'Renovierung',
    description: 'Zeigen Sie das Potenzial von Bestandsimmobilien.',
    icon: PenTool
  }, {
    title: 'Grundriss',
    description: '2D-Pläne werden zu verständlichen 3D-Ansichten.',
    icon: Grid
  }, {
    title: 'Animation',
    description: 'Bewegte Bilder für Exposés und Präsentationen.',
    icon: Video
  }];
  return <section id="services" className="py-16 bg-white" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-214">
          <h2 className="text-3xl sm:text-4xl font-semibold text-black mb-3" data-id="element-215">
            Unsere Leistungen
          </h2>
          <p className="text-lg font-light text-neutral-500" data-id="element-216">
            Präzise Visualisierungslösungen für jeden Schritt Ihres
            Immobilienprojekts.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-217">
          {services.map(service => <div key={service.title} className="group p-5 rounded-2xl bg-white border border-neutral-200 hover:border-neutral-300 transition-all duration-300" data-id="element-218">
              <div className="flex items-center gap-3" data-id="element-219">
                <div className="w-9 h-9 bg-neutral-100 border border-neutral-200 rounded-xl flex items-center justify-center group-hover:bg-black group-hover:border-black transition-colors duration-300" data-id="element-220">
                  <service.icon className="w-[18px] h-[18px] text-black group-hover:text-white transition-colors duration-300" data-id="element-221" />
                </div>
                <h3 className="text-xl font-medium text-black" data-id="element-222">
                  {service.title}
                </h3>
              </div>
              <p className="mt-2 font-light text-neutral-500 leading-relaxed" data-id="element-223">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}